// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"349":"6874ccf6","594":"070ed41e","648":"15d3a107"}[chunkId] + ".js";
};